import React, { useState } from 'react'

import {
    Dialog, DialogActions, DialogContent, DialogTitle, useMediaQuery,
    FormGroup, FormControlLabel, Checkbox, Button
} from '@mui/material';

import { useTheme } from '@mui/material/styles';

const RejectDialog = ({ isOpen, onClose, onConfirm }) => {
    const [selectedReasons, setSelectedReasons] = useState([]);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const definedRejectReasons = [
        "Tampered/Unclear document image",
        "Face is not matching with the images on the document",
        "Unable to read the attributes on the document",
        "Not enough Trust Factor scores for application to be approved"
    ]

    const handleReasonToggle = (reason) => {
        setSelectedReasons(prev => {
            if (prev.includes(reason)) {
                return prev.filter(r => r !== reason);
            }
            return [...prev, reason];
        });
    };

    const handleConfirm = async () => {
        if (selectedReasons.length === 0) {
            return;
        }
        const reasonsText = selectedReasons.join('; ');
        await onConfirm(reasonsText);
    };

    return (

        <Dialog
            fullScreen={fullScreen}
            open={isOpen}
            onClose={onClose}
            aria-labelledby="responsive-dialog-title"
            sx={{
                "& .MuiPaper-root": {
                    border: '2px solid #264E5A',
                    borderRadius: '8px',
                    padding: '1rem',
                }
            }}>

            <DialogTitle id="responsive-dialog-title">Confirm your Reject decision</DialogTitle>

            <DialogContent>

                <span>Please select an option from the drop down below for rejecting this application</span>
                <FormGroup sx={{ marginBlock: '1rem' }}>
                    {/* TODO: Optimize the code for rendering multiple checkboxes */}

                    {definedRejectReasons.map((reason) => (
                        <FormControlLabel
                            key={reason}
                            control={
                                <Checkbox
                                    checked={selectedReasons.includes(reason)}
                                    onChange={() => handleReasonToggle(reason)}
                                    sx={{
                                        color: '#264E5A',
                                        '&.Mui-checked': {
                                            color: '#00454E',
                                        },
                                    }}
                                />
                            }
                            label={reason}
                        />
                    ))}
                </FormGroup>

                <span>
                    Are you sure you want to reject this application? Once rejected,
                    the application status will be updated, and this action cannot be undone.
                </span>
            </DialogContent>

            <DialogActions sx={{ padding: '1rem 1.5rem' }}>
                <Button
                    variant='outlined'
                    autoFocus
                    onClick={onClose}
                    sx={{
                        padding: '1rem 3rem',
                        color: '#00707E',
                        borderColor: "#00707E",
                        textTransform: 'none',
                    }}>
                    Cancel
                </Button>

                <Button
                    variant='contained'
                    onClick={handleConfirm}
                    disabled={selectedReasons.length === 0}
                    sx={{
                        padding: '1rem 3rem',
                        textTransform: 'none',
                        backgroundColor: selectedReasons.length === 0 ? '#DC440580' : '#DC4405'
                    }}>
                    Confirm reject
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default RejectDialog